/**
 * ViewPdfWindow共通コンポーネントのInput用のVO
 */
 export class ViewPdfWindowInVO {
  /**
   * PDFファイルのファイル名
   */
  filename!: string;

  /**
   * Base64形式の文字列のPDFファイル
   */
  pdfBase64!: string;
}
